import { render } from "./MediaImage.vue?vue&type=template&id=7b514250"
import script from "./MediaImage.vue?vue&type=script&lang=js"
export * from "./MediaImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Layout/MediaImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b514250"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b514250', __exports__)) {
    api.reload('7b514250', __exports__)
  }
  
  module.hot.accept("./MediaImage.vue?vue&type=template&id=7b514250", () => {
    api.rerender('7b514250', render)
  })

}


export default __exports__